import React from "react";
import { Route, Switch } from "react-router-dom";
import { PATH_IMPERSONATE } from "./paths";
import { RouteImpersonate } from "./routes/RouteImpersonate";

export const Impersonation: React.FC = () => (
  <Switch>
    <Route path={PATH_IMPERSONATE} component={RouteImpersonate} />
  </Switch>
);
